import { responsiveFontSize, theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';
var text = theme.text;
var sectionTitleSizes = {
  XXS: text.HEADING.XS,
  L: text.HEADING.SM
};
export var title = /*#__PURE__*/css(["", " margin:0;"], responsiveFontSize(sectionTitleSizes));
export var container = /*#__PURE__*/css(["display:flex;justify-content:center;"]);